<app-header #header title="Permits"></app-header>

<ion-content fullscreen="true" scrollEvents="true" [appHideHeader]="header"   >
  <app-header-content ></app-header-content>
  <app-pagecontent [path]="'permits'"></app-pagecontent>

    <ion-progress-bar
      *ngIf="loaderSRV.progressBarLoading && platformSRV.device=='desktop'"
      color="dark"
      type="indeterminate"
    ></ion-progress-bar>
    <ion-grid >
      <ion-row>
        <ion-col size="12">
          <h2 class="subheader-regular" style="text-align: center;">
            {{
              ('keys.data.users_menu.permits' | translate : {Default:'Permits'}) || 'Permits'
              }}
          </h2>
        </ion-col>
      </ion-row>
      <ion-row *ngIf="loaded==true && errorMessage=='' && dataService.settings['temp_permits']?.['enable_qr_codes']=='1' && platformSRV.width<=environment.maxTabletWidth">
        <ion-col class="ion-no-padding">
          <ion-item (click)="openScanner()"  lines="none" class="paragraph-regular" >
            <ion-label slot="end" style="text-align: right;" class="ion-text-wrap ion-no-margin" color="primary"   style="cursor: pointer;">
              {{("keys.data.permits.scan_qr" | translate : {Default:"Scan QR code"}) || "Scan QR code"}}
            </ion-label>
          </ion-item>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col
        class="single-col-wider"
        >
          <ion-searchbar
            [disabled]="errorMessage!==''"
            debounce="100"
            (ionChange)="search($event)"
            style="--border-radius: 0.5em"
            inputmode="text"
            [(ngModel)]="searchItem"
            showCancelButton="focus"
            animated
          ></ion-searchbar>
        </ion-col>
      </ion-row>
      
    </ion-grid>

   
      <ion-grid class="ion-no-padding" style="min-height:75%;">
        <div *ngIf="loaded==false">
        <ion-row   *ngFor="let x of [0, 1, 2, 3]" >
          <ion-col
           
          class="single-col-wider"
          >
            <ion-card>
              <ion-card-header style="text-align: center; font-weight: bold">
                <ion-title
                  ><ion-skeleton-text
                    animated
                    style="width: 60%"
                  ></ion-skeleton-text
                ></ion-title>
                <ion-card-subtitle
                  ><ion-skeleton-text
                    animated
                    style="width: 60%"
                  ></ion-skeleton-text
                ></ion-card-subtitle>
              </ion-card-header>
              <ion-card-content>
                <ion-row>
                  <ion-col>
                    <ion-item>
                      <ion-skeleton-text
                        animated
                        style="width: 40%"
                      ></ion-skeleton-text>
                    </ion-item>
                  </ion-col>
                </ion-row>
                <ion-row>
                  <ion-col>
                    <ion-item>
                      <ion-skeleton-text
                        animated
                        style="width: 40%"
                      ></ion-skeleton-text>
                    </ion-item>
                  </ion-col>
                </ion-row>
                <ion-row>
                  <ion-col>
                    <ion-item>
                      <ion-skeleton-text
                        animated
                        style="width: 40%"
                      ></ion-skeleton-text>
                    </ion-item>
                  </ion-col>
                </ion-row>
              </ion-card-content>
            </ion-card>
          </ion-col>
        </ion-row>
      </div>
        <ion-row *ngIf="loaded==true && errorMessage!==''">
          <ion-col  class="single-col-wider">
            <ion-card>
              <ion-card-content style="text-align: center">
                <ion-grid>
                  <ion-row>
                    <ion-col>
                      <ion-label class="paragraph-regular">
                        {{errorMessage}}
                      </ion-label>
                    </ion-col>
                  </ion-row>
                  <ion-row>
                    <ion-col class="ion-text-center">
                      <ion-button
                       
                        color="primary"
                        (click)="vehiclesSRV.openAddVehicleModal()"
                      >
                        <ion-icon slot="start" name="create-outline"></ion-icon>
                        {{ ('keys.data.vehicles.add_vehicle' |  translate : {Default:'Add Vehicle'}) || "Add Vehicle"}}
                      </ion-button>
                     </ion-col>
                  </ion-row>
                </ion-grid>
               
              </ion-card-content>
            </ion-card>
          </ion-col>
        </ion-row>
        <ion-row *ngIf="loaded==true && errorMessage==''">
          <ion-col
            class="ion-no-padding single-col-wider"
            
          >
            
            <ion-card *ngFor="let lot of permits['lots'] | keyvalue | filter:searchItem;"  style="border-radius: 8px;" class="card-shadow-7">
         
              <ion-grid class="ion-no-padding" >
                <ion-row  style="background: var(--Blue-Shade, #1D227E)">
                  <ion-col style="padding: 0.4em;">
                    <ion-item lines="none" style="--background:trasnparent">
                      <ion-label class="card-header-unique" style="color: white;">
                        {{lot.value.LotName}}
                      </ion-label>
                      <ion-icon *ngIf="lot.value.enable_lot_password" (click)="presentLotPasswordPopover($event)"  style="text-align: right;color: white;cursor: pointer;margin-right: 0.5em;" name="lock-closed"></ion-icon>
                      <ion-icon *ngIf="lot.value.photo" (click)="openImageModal(lot.value.photo)" style="text-align: right;color: white;cursor: pointer;" name="map"></ion-icon>
                    </ion-item>
                   
                  </ion-col>
                  
                  </ion-row>
                  <ion-row  *ngIf="lot.value.Location">    
                    <ion-col  class="ion-padding">
                      <div #divs>
                      <div  class="permitDescription" >
                      <ion-label class="paragraph-regular" >
                        {{lot.value.Location}}
                      </ion-label>
                    </div>
                      <ion-label  style="color: var(--Red-Shade, #A02021);text-decoration: underline;cursor: pointer;"
                      
                      class="paragraph-bold" (click)="showMore($event)">Show more</ion-label>
                      <ion-label  style="color: var(--Red-Shade, #A02021); text-decoration: underline;cursor: pointer;"  class="paragraph-bold" (click)="showLess($event)">Show less</ion-label>
                      </div>
                    </ion-col>
                  </ion-row>
                 
                  
                  <ion-row>
                    <ion-col>
                      <ion-accordion-group>
                        <div *ngFor="let permit of lot.value.PermitTypes">
                          <div
                            *ngIf="permit.PermitType == 'STANDARD'"
                            class="permit"
                          >
                            <ion-card  class="standard card-shadow-3" >
                              <ion-accordion [disabled]="!permit.Visible">
                                <ion-item class="paragraph-regular"
                                  toggle-icon="caret-down-circle"
                                  slot="header"
                                  style="
                                    --padding-end: 0px;
                                    --inner-padding-end: 0px;
                                  "
                                >
                                  <ion-label  
                                    >{{ ('keys.data.permits.standard_permit' |
                                    translate : {Default:'Standard Permit'}) || 'Standard Permit' }}</ion-label
                                  >
                                  <span *ngIf="!permit.Visible" class="paragraph-bold" style="text-align: right;color: #dc3545;"> {{("keys.data.common.sold_out" | translate : {Default:"Sold Out"}) || "Sold Out"}}</span>
                                  </ion-item
                                >
                                <div slot="content">
                                  <ion-col *ngIf="permit.PermitType == 'STANDARD'"
                                  >
                                    
                                      <ion-grid class="ion-no-padding">
                                        <ion-row>
                                          <ion-col>
                                            <ion-item lines="none" class="paragraph-regular">
                                              <ion-label 
                                             
                                              class="ion-text-wrap"
                                                > From
                                              </ion-label>
                                              <span 
                                              class="ion-text-wrap"
                                              style="text-align: right"
                                                >
                                                {{permit.ActiveStart | date:dataService.settings['system']['datemask']}}
                                              </span>
                                            </ion-item>
                                          </ion-col>
                                        </ion-row>
                                        <ion-row>
                                          <ion-col>
                                            <ion-item lines="none" class="paragraph-regular">
                                              <ion-label
                                              class="ion-text-wrap"
                                                > To
                                              </ion-label>
                                              <span 
                                              class="ion-text-wrap "
                                              style="text-align: right"
                                                >
                                                {{permit.SemEnd |
                                                  date:dataService.settings['system']['datemask']}}
                                                
                                              </span>
                                            </ion-item>
                                          </ion-col>
                                        </ion-row>
                                        <ion-row>
                                          <ion-col
                                            size="12"
                                          >
                                          <ion-item lines="none" class="paragraph-regular">
                                            <ion-label *ngIf="permit.PermitTaken < permit.PermitTotal"  
                                            class="ion-text-wrap"
                                            >
                                            {{permit.PermitTotal -
                                              permit.PermitTaken}}
                                              {{('keys.data.common.remaining' | translate : {Default:'Remaining'}) || 'Remaining'}}</ion-label
                                            > 
                                            <ion-label  *ngIf="permit.PermitTaken >= permit.PermitTotal"
                                              color="danger" 
                                            class="ion-text-wrap"
                                             
                                            >
                                            {{permit.PermitTotal -
                                              permit.PermitTaken}}
                                              {{('keys.data.common.remaining' | translate : {Default:'Remaining'}) || 'Remaining'}}</ion-label
                                            > 
                                            <span 
                                              class="ion-text-wrap "
                                              style="text-align: right">
                                            {{permit.DefaultCost | currency}}
                                            </span>
                                            
                                          </ion-item>
                                          </ion-col>
                                        </ion-row>
                                        <ion-row>
                                          <ion-col class="ion-text-center" style="margin-bottom: 0.5em;">
                                            <ion-button
                                              *ngIf="permit.PermitTaken < permit.PermitTotal"
                                              (click)="openStandardPermitModal(lot.value)"
                                              color="primary"
                                             
                                            >
                                            {{ ('keys.data.permits.get_standard_permit' | translate : {Default:'Get Standard Permit'}) ||
                                            'Get Standard Permit' }}
                                              
                                            </ion-button>
                                            <ion-button
                                              *ngIf="permit.PermitTaken >= permit.PermitTotal"
                                              color="primary"
                                             
                                              disabled
                                            >
                                            {{ ('keys.data.permits.get_standard_permit' | translate : {Default:'Get Standard Permit'}) ||
                                            'Get Standard Permit' }}
                                            </ion-button>
                                          </ion-col>
                                        </ion-row>
                                      </ion-grid>
                                    
                                  </ion-col>
                                </div>
                              </ion-accordion>
                            </ion-card>
                            <div
                              class="waiting"
                              *ngIf="permit.AllowOnWaitList == '1'"
                            >
                            <ion-card class="card-shadow-3">
                              <ion-accordion>
                                <ion-item class="paragraph-regular"
                                  slot="header"
                                  style="
                                    --padding-end: 0px;
                                    --inner-padding-end: 0px;
                                  "
                                >
                                  <ion-label 
                                    >{{('keys.data.permits.waiting_list'|translate : {Default:'Waiting  List'})||"Waiting List"}}</ion-label></ion-item>
                                <div slot="content">
                                 
                                    <ion-grid class="ion-no-padding">
                                      <ion-row>
                                        <ion-col>
                                          <ion-item lines="none" class="paragraph-regular">
                                            <ion-label
                                            class="ion-text-wrap"
                                              > From
                                            </ion-label>
                                            <span 
                                              class="ion-text-wrap"
                                              style="text-align: right"
                                              >
                                              {{permit.ActiveStart | date:dataService.settings['system']['datemask']}}
                                            </span>
                                          </ion-item>
                                        </ion-col>
                                      </ion-row>
                                      <ion-row>
                                        <ion-col>
                                          <ion-item lines="none" class="paragraph-regular">
                                            <ion-label
                                            class="ion-text-wrap"
                                              > To
                                            </ion-label>
                                            <span 
                                              class="ion-text-wrap"
                                              style="text-align: right"
                                              >
                                              {{permit.SemEnd |
                                                date:dataService.settings['system']['datemask']}}
                                              
                                            </span>
                                          </ion-item>
                                        </ion-col>
                                      </ion-row>
                                      <ion-row>
                                        <ion-col class="ion-text-center" style="margin-bottom: 0.5em;">
                                          <ion-button 
                                            (click)="openWaitingList(lot.value)"
                                            color="primary"
                                           
                                          >
                                            {{
                                            ('keys.data.permits.join_waiting_list' |
                                            translate : {Default:'Join Waiting List'}) || 'Join Waiting List' }}
                                            
                                          </ion-button>
                                        </ion-col>
                                      </ion-row>
                                    </ion-grid>
                                  
                                </div>
                              </ion-accordion>
                            </ion-card>
                            </div>
                          </div>
                          <div
                            class="temp"
                            *ngIf="permit.PermitType == 'TEMP' && permit.Visible"
                          >
                          <ion-card class="card-shadow-3">
                            <ion-accordion>
                              <ion-item class="paragraph-regular"
                                slot="header"
                                style="--padding-end: 0px; --inner-padding-end: 0px"
                              >
                                <ion-label 
                                  >{{ ('keys.data.permits.temp_permit' | translate : {Default:'Temporary Permit'})
                                  || 'Temporary Permit' }}</ion-label
                                ></ion-item
                              >
                              <div slot="content">
                                
                                  <ion-grid class="ion-no-padding">
                                    
                                    <ion-row>
                                      <ion-col >
                                        <ion-item lines="none" class="paragraph-regular"
                                          *ngFor="let hour of lot.value.Hours | keyvalue: sortByDuration"
                                        >
                                          <ion-label
                                           class="ion-text-wrap"
                                            *ngIf="hour.value.duration<2"
                                          >
                                            {{hour.value.duration}} hour
                                            
                                          </ion-label>
                                          <ion-label
                                           class="ion-text-wrap"
                                            *ngIf="hour.value.duration>1"
                                          >
                                            {{hour.value.duration}} {{ ('keys.data.permits.temporary_hours' |
                                            translate : {Default:'Hours'}) || 'Hours' }}
                                          </ion-label>
                                          <span 
                                          class="ion-text-wrap"
                                          style="text-align: right"
                                            >{{hour.value.price |
                                            currency}}</span>
                                        </ion-item>
                                      </ion-col>
                                    </ion-row>
                                    <ion-row>
                                      <ion-col
                                        *ngIf="permit.TempPermitCost"
                                        
                                      >
                                        <ion-item lines="none" class="paragraph-regular">
                                          <ion-label  class="ion-text-wrap">
                                            {{ ('keys.data.permits.temp_daily' |
                                            translate : {Default:'Daily'}) || 'Daily' }}
                                          </ion-label>
                                          <span 
                                          class="ion-text-wrap"
                                          style="text-align: right"
                                            >{{permit.TempPermitCost |
                                            currency}}</span>
                                        </ion-item>
                                      </ion-col>
                                    </ion-row>
                                    
                                    <ion-row>
                                      <ion-col
                                        size="12"
                                        style="text-align: center"
                                      >
                                      <ion-item lines="none" class="paragraph-regular">
                                       
                                        <ion-label class="ion-text-wrap"
                                        >
                                          {{('keys.data.common.remaining' | translate) || 'Remaining'}}</ion-label
                                        >
                                        <span *ngIf="!permit.allowTempPermit"
                                        color="danger"  class="ion-text-wrap"
                                        style="text-align: right">
                                          {{permit.counts.temp_remaining }}
                                        </span>
                                        <span *ngIf="permit.allowTempPermit && permit.counts.temp_remaining>0"  class="ion-text-wrap"
                                        style="text-align: right">
                                          {{permit.counts.temp_remaining }}
                                        </span>
                                      </ion-item>
                                      </ion-col>
                                    </ion-row>
                                    <ion-row  *ngIf="permit.TempPermitOver30days">
                                      <ion-col >
                                        <ion-item lines="none" class="paragraph-regular">
                                        <ion-label  class="ion-text-wrap"
                                         
                                          >{{('keys.data.permits.over_30_days'|translate : {Default:'Over 30 Days'})||"Over 30 Days"}}
                                            </ion-label
                                        >
                                      </ion-item>
                                      </ion-col>
                                    </ion-row>
                                    <ion-row>
                                      <ion-col class="ion-text-center" style="margin-bottom: 0.5em;" >
                                        <ion-button
                                        *ngIf="permit.allowTempPermit"
                                          (click)="openTemporaryPermitModal(lot.value)"
                                          color="primary"
                                         
                                        >
                                        {{ ('keys.data.permits.get_temp_permit' | translate : {Default:'Get Temp Permit'}) ||
                                        'Get Temp Permit' }}
                                          
                                        </ion-button>
                                        <ion-button
                                        *ngIf="!permit.allowTempPermit"
                                              color="primary"
                                             
                                              disabled
                                            >
                                            {{ ('keys.data.permits.get_temp_permit' | translate : {Default:'Get Temp Permit'}) ||
                                        'Get Temp Permit' }}
                                            </ion-button>
                                      </ion-col>
                                    </ion-row>
                                    
                                  </ion-grid>
                                
                              </div> 
                            </ion-accordion>
                          </ion-card>
                          </div>
                        </div>
                      </ion-accordion-group>
                    </ion-col>
                  </ion-row>
                </ion-grid>
              
             
                
               
              
            </ion-card>
              
            
          </ion-col>
        </ion-row>
        <ion-row *ngIf=" loaded==true && errorMessage=='' && permits['lots'].length<1" style="  
       align-items: center;
     ">
       <ion-col  sizeSm="12" sizeMd="8" offsetMd="2" sizeLg="4.5" offsetLg="3.75">
        <ion-card>
          <ion-card-content style="text-align: center">
            <ion-label style="font-weight: bold">
            No lots are available at the moment.
            </ion-label>
          </ion-card-content>
        </ion-card>
       </ion-col>
       </ion-row>
      </ion-grid>
    
 
  <ion-footer class="ion-no-border">
    <app-footer></app-footer>
  </ion-footer>
</ion-content>
